module.exports = __webpack_public_path__ + "static/media/slaughter_150.10fd30a3.png";